import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

export default function TopNav() {
  // Logged in user
  const user = JSON.parse(localStorage.getItem("user"));

  console.log("USER:", user);

  const [cartCount, setCartCount] = useState(0);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const fetchCart = async () => {
      try {
        const res = await fetch("https://eleven11-i6v4.onrender.com/api/cart");
        const data = await res.json();

        const total = (data.items || []).reduce(
          (sum, item) => sum + (item.qty || 1),
          0
        );

        setCartCount(total);
      } catch {}
    };

    fetchCart();

    const interval = setInterval(fetchCart, 5000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);

      if (window.innerWidth > 768) {
        setMobileMenuOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const styles = {
    nav: {
      position: "sticky",
      top: 0,
      zIndex: 1000,

      width: "100%",

      background: "rgba(246,247,251,0.92)",

      backdropFilter: "blur(18px)",
      WebkitBackdropFilter: "blur(18px)",

      borderBottom: "1px solid rgba(0,0,0,0.04)",

      paddingTop: "env(safe-area-inset-top)"
    },

    inner: {
      width: "100%",
      maxWidth: "1400px",

      margin: "0 auto",

      height: isMobile ? "60px" : "52px",

      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",

      padding: isMobile ? "0 16px" : "0 24px",

      boxSizing: "border-box"
    },

    logo: {
      fontSize: isMobile ? "16px" : "15px",

      fontWeight: 600,

      letterSpacing: isMobile ? "4px" : "3px",

      cursor: "pointer",

      opacity: 0.95,

      color: "#1d1d1f",

      textDecoration: "none",

      whiteSpace: "nowrap"
    },

    desktopNav: {
      display: "flex",
      alignItems: "center",
      gap: "26px",

      marginLeft: "40px",

      flex: 1
    },

    link: {
      fontSize: "13px",
      fontWeight: 400,
      color: "#1d1d1f",
      cursor: "pointer",
      opacity: 0.82,
      textDecoration: "none",
      whiteSpace: "nowrap",
      transition: "0.2s ease"
    },

    right: {
      display: "flex",
      alignItems: "center",
      gap: isMobile ? "10px" : "18px"
    },

    account: {
      fontSize: "13px",
      cursor: "pointer",
      opacity: 0.9,
      color: "#1d1d1f",
      textDecoration: "none"
    },

    signup: {
      fontSize: "13px",

      padding: isMobile ? "8px 12px" : "6px 14px",

      borderRadius: "999px",

      border: "1px solid rgba(0,0,0,0.08)",

      background: "#fff",

      color: "#1d1d1f",

      textDecoration: "none",

      cursor: "pointer",

      fontWeight: 500,

      whiteSpace: "nowrap"
    },

    cartBtn: {
      position: "relative",

      display: "flex",
      alignItems: "center",
      justifyContent: "center",

      width: isMobile ? 40 : 36,
      height: isMobile ? 40 : 36,

      borderRadius: 14,

      background: "rgba(0,0,0,0.05)",

      textDecoration: "none",

      flexShrink: 0
    },

    cartBadge: {
      position: "absolute",

      top: -3,
      right: -3,

      width: 17,
      height: 17,

      borderRadius: "50%",

      background: "#0a84ff",

      color: "#fff",

      fontSize: 10,
      fontWeight: 800,

      display: "flex",
      alignItems: "center",
      justifyContent: "center",

      border: "2px solid #F6F7FB"
    },

    hamburger: {
      width: 40,
      height: 40,

      borderRadius: 12,

      border: "1px solid rgba(0,0,0,0.06)",

      background: "#fff",

      display: "flex",
      flexDirection: "column",

      alignItems: "center",
      justifyContent: "center",

      gap: 4,

      cursor: "pointer",

      flexShrink: 0
    },

    line: {
      width: 16,
      height: 1.5,
      background: "#1d1d1f",
      borderRadius: 999
    },

    mobileMenu: {
      width: "100%",

      background: "rgba(255,255,255,0.98)",

      backdropFilter: "blur(20px)",
      WebkitBackdropFilter: "blur(20px)",

      borderTop: "1px solid rgba(0,0,0,0.04)",

      padding: "10px 16px 24px 16px",

      boxSizing: "border-box"
    },

    mobileLink: {
      display: "block",

      padding: "14px 4px",

      fontSize: "15px",

      fontWeight: 500,

      color: "#1d1d1f",

      textDecoration: "none",

      borderBottom: "1px solid rgba(0,0,0,0.04)"
    }
  };

  return (
    <div style={styles.nav}>
      <div style={styles.inner}>
        {/* LEFT SIDE */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: isMobile ? "12px" : "0px"
          }}
        >
          {/* MOBILE MENU BUTTON */}
          {isMobile && (
            <button
              style={styles.hamburger}
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            >
              <div style={styles.line} />
              <div style={styles.line} />
              <div style={styles.line} />
            </button>
          )}

          {/* LOGO */}
          <Link to="/" style={styles.logo}>
            ELEVEN
          </Link>
        </div>

        {/* DESKTOP NAV */}
        {!isMobile && (
          <div style={styles.desktopNav}>
            <Link to="/category/marine-detailing" style={styles.link}>
              Marine Detailing
            </Link>

            <Link to="/category/lubricants" style={styles.link}>
              Lubricants
            </Link>

            <Link to="/category/accessories" style={styles.link}>
              Accessories
            </Link>

            <Link to="/category/new-oem" style={styles.link}>
              New OEM Parts
            </Link>

            <Link to="/category/used-oem" style={styles.link}>
              Used OEM Parts
            </Link>

            <Link to="/category/fluids" style={styles.link}>
              Fluids & Maintenance
            </Link>
          </div>
        )}

        {/* RIGHT SIDE */}
        <div style={styles.right}>
          {!isMobile && (
            <>
              <Link to="/account" style={styles.account}>
                Account
              </Link>

              <Link
                to={user ? "/account" : "/signup"}
                style={styles.signup}
              >
                {user ? user.firstName : "Sign up"}
              </Link>
            </>
          )}

          {/* CART */}
          <Link to="/checkout" style={styles.cartBtn}>
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#1d1d1f"
              strokeWidth="1.8"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z" />
              <line x1="3" y1="6" x2="21" y2="6" />
              <path d="M16 10a4 4 0 01-8 0" />
            </svg>

            {cartCount > 0 && (
              <span style={styles.cartBadge}>{cartCount}</span>
            )}
          </Link>
        </div>
      </div>

      {/* MOBILE MENU */}
      {isMobile && mobileMenuOpen && (
        <div style={styles.mobileMenu}>
          <Link
            to="/category/marine-detailing"
            style={styles.mobileLink}
            onClick={() => setMobileMenuOpen(false)}
          >
            Marine Detailing
          </Link>

          <Link
            to="/category/lubricants"
            style={styles.mobileLink}
            onClick={() => setMobileMenuOpen(false)}
          >
            Lubricants
          </Link>

          <Link
            to="/category/accessories"
            style={styles.mobileLink}
            onClick={() => setMobileMenuOpen(false)}
          >
            Accessories
          </Link>

          <Link
            to="/category/new-oem"
            style={styles.mobileLink}
            onClick={() => setMobileMenuOpen(false)}
          >
            New OEM Parts
          </Link>

          <Link
            to="/category/used-oem"
            style={styles.mobileLink}
            onClick={() => setMobileMenuOpen(false)}
          >
            Used OEM Parts
          </Link>

          <Link
            to="/category/fluids"
            style={styles.mobileLink}
            onClick={() => setMobileMenuOpen(false)}
          >
            Fluids & Maintenance
          </Link>

          <Link
            to="/account"
            style={styles.mobileLink}
            onClick={() => setMobileMenuOpen(false)}
          >
            Account
          </Link>

<Link
  to={user ? "/account" : "/auth"}
  style={{
    ...styles.mobileLink,
    borderBottom: "none",
    fontWeight: 600
  }}
  onClick={() => setMobileMenuOpen(false)}
>
  {user ? user.firstName : "Sign up"}
</Link>

        </div>
      )}
    </div>
  );
}